define('modules/form_editor/models/custom_gender_item',['require','exports','module','./dropdown_item'],function(require, exports, module){
  "use strict";
  var DropDownItem = require("./dropdown_item");
  module.exports = DropDownItem.extend({
    defaults: {
      text: "",
      socialBinding: "",
      correodirectBinding: ""
    },
    initialize: function(options) {
      module.exports.__super__.initialize.apply(this, arguments);
      // backwards compatibility
      if (!options.correodirectBinding)
        this.initializeCorreodirectBinding();
    },
    correodirectBindingOptions: ["M", "F"],
    initializeCorreodirectBinding: function() {
      var correodirectMapping = { male: "M", female: "F" },
          socialBinding = this.get("socialBinding");
      this.set("correodirectBinding", correodirectMapping[socialBinding], { silent: true });
    }
  });
});

